__turbopack_context__.v({
  "className": "jetbrains_mono_430875c7-module__UW5mEG__className",
  "variable": "jetbrains_mono_430875c7-module__UW5mEG__variable",
});
